import React, { useState, useEffect } from 'react';
import { api } from '../api.js';
import { Cargando, ErrorCarga } from './Comunes.jsx';
import { DOW, addDaysIso, isoOffset, fechaLarga } from '../utiles/fechas.js';

export function Booking({ sede, date, setDate, onPick }) {
  const s = sede;
  const [huecos, setHuecos] = useState({ datos: null, cargando: true, error: null });

  useEffect(() => {
    let vigente = true;
    setHuecos({ datos: null, cargando: true, error: null });
    api.huecos(s.id, date)
      .then((datos) => { if (vigente) setHuecos({ datos, cargando: false, error: null }); })
      .catch((error) => { if (vigente) setHuecos({ datos: null, cargando: false, error }); });
    // Al cambiar de día deprisa, la respuesta de un día anterior puede llegar
    // después que la del actual y pintar horas equivocadas.
    return () => { vigente = false; };
  }, [s.id, date]);

  const d0 = new Date(date + 'T00:00:00');
  const dow = (d0.getDay() + 6) % 7;
  const lunes = addDaysIso(date, -dow);
  const hoy = isoOffset(0);
  const mesRaw = d0.toLocaleDateString('es-CL', { month: 'long' });
  const mes = mesRaw.charAt(0).toUpperCase() + mesRaw.slice(1) + ' ' + d0.getFullYear();
  const dias = Array.from({ length: 7 }, (_, i) => addDaysIso(lunes, i));

  // El backend devuelve todos los bloques de la jornada; si el día es hoy, los
  // que ya pasaron no son reservables. Se ocultan en vez de ofrecerlos y dejar
  // que el servidor los rechace después, que es peor experiencia.
  const ahora = new Date();
  const minutosAhora = ahora.getHours() * 60 + ahora.getMinutes();
  const disponibles = (huecos.datos || []).filter((b) => {
    if (date !== hoy) return true;
    const [h, m] = b.hora.split(':').map(Number);
    return h * 60 + m > minutosAhora;
  });
  const quedanLibres = disponibles.some((b) => b.libres > 0);

  return (
    <div className="wrap book">
      <div className="book-sede">{s.comuna} · Centro TUNE</div>
      <h1 className="book-title">Elige día y hora</h1>

      <div className="daybar">
        <button className="db-btn" onClick={() => setDate(addDaysIso(date, -7))}>‹</button>
        <span className="db-month">{mes}</span>
        <button className="db-btn" onClick={() => setDate(addDaysIso(date, 7))}>›</button>
      </div>

      <div className="dayrow">
        {dias.map((iso) => {
          const d = new Date(iso + 'T00:00:00');
          const pasado = iso < hoy;
          return (
            <button key={iso} disabled={pasado}
                    className={'day' + (iso === hoy ? ' today' : '') + (iso === date ? ' sel' : '')}
                    style={pasado ? { opacity: 0.35, cursor: 'default' } : undefined}
                    onClick={() => !pasado && setDate(iso)}>
              <div className="dw">{DOW[d.getDay()]}</div>
              <div className="dn">{d.getDate()}</div>
            </button>
          );
        })}
      </div>

      <div className="slots-lead">{fechaLarga(date)}</div>

      {huecos.cargando ? <Cargando que="los horarios" /> : null}
      {huecos.error ? <ErrorCarga error={huecos.error} /> : null}

      {huecos.datos && !quedanLibres ? (
        <div className="slots-empty">
          No quedan horas libres este día.<br />Prueba con otra fecha.
        </div>
      ) : null}

      {huecos.datos && quedanLibres ? (
        <div className="slots">
          {disponibles.map((b) => b.libres > 0
            ? <button key={b.hora} className="slot" onClick={() => onPick(b.hora)}>{b.hora}</button>
            : <div key={b.hora} className="slot full">{b.hora}</div>)}
        </div>
      ) : null}
    </div>
  );
}
